"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqs = [{
  question: "How does the cash offer process work for my land?",
  answer: "Our process is streamlined for speed. Once you submit your property details, our team performs a digital survey and market analysis. We typically provide a firm cash offer within 48 hours, handling all paperwork and administrative overhead ourselves."
}, {
  question: "Are there any commissions or hidden closing costs?",
  answer: "Absolutely not. Unlike listing with a broker, Brentwood Enterprises charges zero commissions. We cover 100% of the closing costs, meaning the cash offer you accept is the exact amount you receive at the time of closing."
}, {
  question: "What types of vacant land do you purchase?",
  answer: "We purchase all varieties of acreage nationwide, including rural tracts, residential infill lots, agricultural land, and timberland. We are interested in your property regardless of its current condition or geographic location."
}, {
  question: "How quickly can we close the transaction?",
  answer: "We specialize in rapid liquidity. Depending on the local title company or attorney, we can often close and distribute funds in as little as 10 to 21 days. We work on your timeline to ensure a stress-free transition."
}, {
  question: "What if my property has back taxes or legal issues?",
  answer: "We are experienced in complex title situations. In most cases, we can settle delinquent taxes or minor liens directly out of the purchase price at closing, allowing you to walk away from the property with cash in hand."
}];
export default function CommonQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="148146" id="common-inquiries" className="w-full py-24 bg-background text-foreground overflow-hidden dark">
      <div ref={ref} className={`container mx-auto px-4 md:px-6 max-w-3xl transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold tracking-tighter mb-4 text-foreground font-sans">
            Common Inquiries
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto font-sans">
            Transparent answers regarding our nationwide land acquisition process, cash liquidity, and rapid closing timelines.
          </p>
        </div>

        <div className="bg-card/40 backdrop-blur-md rounded-md p-6 md:p-8 shadow-xl border border-white/10">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-border/50">
                <AccordionTrigger className="text-lg font-bold text-left hover:text-primary transition-colors font-sans tracking-tight">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-lg text-muted-foreground leading-relaxed pt-2 pb-6 font-sans">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>

        <div className="mt-12 text-center flex flex-col items-center justify-center space-y-4">
          <p className="text-lg text-muted-foreground font-sans">
            Ready to receive a no-obligation cash offer for your property?
          </p>
          <Button asChild size="lg" className="text-base px-8 bg-primary text-primary-foreground hover:opacity-90 transition-opacity rounded-md font-sans font-bold">
            <Link to="/SellYourLandPage">Get My Cash Offer</Link>
          </Button>
        </div>
      </div>
    </section>;
}